var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    (_vm.minPrice > 0 || _vm.maxPrice > 0) && _vm.minPrice != _vm.maxPrice
      ? _c(
          "div",
          { staticClass: "sidebar-section sidebar-section--1 filter-range" },
          [
            _c("h3", { staticClass: "sidebar-section__header" }, [
              _vm._v("\n                Cena\n            ")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "sidebar-section__wrapper" }, [
              _c("div", { staticClass: "filter-range-wrapper" }, [
                _c(
                  "div",
                  { staticClass: "price-slider" },
                  [
                    _c("vue-slider", {
                      attrs: {
                        min: _vm.minPrice,
                        max: _vm.maxPrice,
                        tooltip: "always"
                      },
                      model: {
                        value: _vm.priceSlider.model,
                        callback: function($$v) {
                          _vm.$set(_vm.priceSlider, "model", $$v)
                        },
                        expression: "priceSlider.model"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "filter-range__wrapper-in" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.priceSlider.model[0],
                        expression: "priceSlider.model[0]"
                      }
                    ],
                    staticClass: "filter-range__input filter-range__lower",
                    attrs: {
                      type: "number",
                      min: _vm.minPrice,
                      max: _vm.maxPrice,
                      step: "1"
                    },
                    domProps: { value: _vm.priceSlider.model[0] },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.priceSlider.model, 0, $event.target.value)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "filter-range__text" }, [
                    _vm._v(
                      "\n                            -\n                        "
                    )
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.priceSlider.model[1],
                        expression: "priceSlider.model[1]"
                      }
                    ],
                    staticClass: "filter-range__input filter-range__upper",
                    attrs: {
                      type: "number",
                      min: _vm.minPrice,
                      max: _vm.maxPrice,
                      step: "1"
                    },
                    domProps: { value: _vm.priceSlider.model[1] },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.priceSlider.model, 1, $event.target.value)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "filter-range__text" }, [
                    _vm._v(
                      "\n                            Kč\n                        "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "filter-range__wrapper-in" },
                  [
                    _c(
                      "b-btn",
                      {
                        staticClass: "mh-filter-btn",
                        attrs: {
                          disabled:
                            _vm.currentMinPrice === _vm.priceSlider.model[0] &&
                            _vm.currentMaxPrice === _vm.priceSlider.model[1]
                        },
                        on: { click: _vm.handlePriceFilter }
                      },
                      [_vm._v("Filtrovat")]
                    )
                  ],
                  1
                )
              ])
            ])
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.filters.brands.length > 0
      ? _c(
          "div",
          { staticClass: "sidebar-section sidebar-section--1 manufacturer" },
          [
            _c("h3", { staticClass: "sidebar-section__header" }, [
              _vm._v("\n                Výrobce\n            ")
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "sidebar-section__wrapper" },
              [
                _c("b-form-group", {
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(ref) {
                          var ariaDescribedby = ref.ariaDescribedby
                          return [
                            _c(
                              "b-form-checkbox-group",
                              {
                                attrs: {
                                  id: "checkbox-group-2",
                                  "aria-describedby": ariaDescribedby,
                                  name: "flavour-2"
                                },
                                on: { change: _vm.handleBrandFilter },
                                model: {
                                  value: _vm.mannufacturers.selected,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.mannufacturers,
                                      "selected",
                                      $$v
                                    )
                                  },
                                  expression: "mannufacturers.selected"
                                }
                              },
                              _vm._l(_vm.filters.brands, function(option) {
                                return _c(
                                  "b-form-checkbox",
                                  {
                                    key: option.id,
                                    attrs: {
                                      value: option.id,
                                      name: "flavour-4a",
                                      stacked: ""
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(option.name) +
                                        " "
                                    ),
                                    _c("small", [
                                      _vm._v("(" + _vm._s(option.count) + ")")
                                    ])
                                  ]
                                )
                              }),
                              1
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    66743348
                  )
                })
              ],
              1
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }